import { lazyRetry } from '~/utils/lazyRetry'
import { ADMIN_ROUTES, PRODUCT_ROUTES } from '~/constants/router'
import {
  productRolesEditable,
  productRolesView,
} from '~/modules/auth/conditions'
import { FLAGS } from '~/constants/flags'
import { POS_STORE_TYPES } from '~/constants/store'

const ProductList = lazyRetry(() => import('~/pages/Products/ProductList'))
const ProductForm = lazyRetry(() => import('~/pages/Products/ProductForm'))
const CovaProductList = lazyRetry(
  () => import('~/pages/Products/CovaProductList'),
)
const CovaProductListV2 = lazyRetry(
  () => import('~/pages/Products/CovaProductListV2'),
)
const CovaProductForm = lazyRetry(
  () => import('~/pages/Products/CovaProductForm'),
)
const CovaProductDetailV2 = lazyRetry(
  () => import('~/pages/Products/CovaProductDetailV2'),
)
const GreenlineProductForm = lazyRetry(
  () => import('~/pages/Products/GreenlineProductForm'),
)
const GreenlineProductDetailV2 = lazyRetry(
  () => import('~/pages/Products/GreenlineProductDetailV2'),
)
const GreenlineProductList = lazyRetry(
  () => import('~/pages/Products/GreenlineProductList'),
)
const GreenlineProductListV2 = lazyRetry(
  () => import('~/pages/Products/GreenlineProductListV2'),
)
const FlowhubProductList = lazyRetry(
  () => import('~/pages/Products/FlowhubProductList'),
)
const FlowhubProductDetailV2 = lazyRetry(
  () => import('~/pages/Products/FlowhubProductDetailV2'),
)
const LightspeedProductListV2 = lazyRetry(
  () => import('~/pages/Products/LightspeedProductListV2'),
)
const LightspeedProductDetailV2 = lazyRetry(
  () => import('~/pages/Products/LightspeedProductDetailV2'),
)
const ShopifyProductList = lazyRetry(
  () => import('~/pages/Products/ShopifyProductList'),
)
const ShopifyProductForm = lazyRetry(
  () => import('~/pages/Products/ShopifyProductForm'),
)
const PantryProductList = lazyRetry(
  () => import('~/pages/Products/PantryProduct/PantryProductList'),
)
const PantryProductEditor = lazyRetry(
  () => import('~/pages/Products/PantryProduct/PantryProductEditor'),
)

const ProductRouters = [
  {
    path: `${ADMIN_ROUTES.STORE}${PRODUCT_ROUTES.PRODUCTS}`,
    component: ProductList,
    covaComponent: CovaProductList,
    greenlineComponent: GreenlineProductList,
    shopifyComponent: ShopifyProductList,
    covaComponentV2: CovaProductListV2,
    greenlineComponentV2: GreenlineProductListV2,
    flowhubComponentV2: FlowhubProductList,
    lightspeedComponentV2: LightspeedProductListV2,
    pantryComponent: PantryProductList,
    pantryAllowedStoreTypes: POS_STORE_TYPES,
    featureFlag: FLAGS.ACD_12337,
    layout: 'admin',
    exact: true,
    roles: productRolesView,
    editRoles: productRolesEditable,
    routeName: 'Products List',
  },
  {
    path: `${ADMIN_ROUTES.STORE}${PRODUCT_ROUTES.TRASH_PRODUCTS}`,
    component: ProductList,
    layout: 'admin',
    exact: true,
    roles: productRolesView,
    editRoles: productRolesEditable,
    xProps: {
      isTrash: true,
    },
    routeName: 'Products Trash List',
  },
  {
    path: `${ADMIN_ROUTES.STORE}${PRODUCT_ROUTES.CREATE_PRODUCT}`,
    component: ProductForm,
    covaComponent: CovaProductForm,
    greenlineComponent: GreenlineProductForm,
    shopifyComponent: ShopifyProductForm,
    pantryComponent: PantryProductEditor,
    pantryAllowedStoreTypes: POS_STORE_TYPES,
    layout: 'admin',
    exact: true,
    roles: productRolesEditable,
    routeName: 'Product Create',
  },
  {
    path: `${ADMIN_ROUTES.STORE}${PRODUCT_ROUTES.EDIT_PRODUCT}`,
    component: ProductForm,
    covaComponent: CovaProductForm,
    greenlineComponent: GreenlineProductForm,
    shopifyComponent: ShopifyProductForm,
    covaComponentV2: CovaProductDetailV2,
    greenlineComponentV2: GreenlineProductDetailV2,
    flowhubComponentV2: FlowhubProductDetailV2,
    lightspeedComponentV2: LightspeedProductDetailV2,
    pantryComponent: PantryProductEditor,
    pantryAllowedStoreTypes: POS_STORE_TYPES,
    featureFlag: FLAGS.ACD_12337,
    layout: 'admin',
    exact: true,
    roles: productRolesView,
    editRoles: productRolesEditable,
    xProps: {
      isEditing: true,
    },
    routeName: 'Product Edit',
  },
]

export default ProductRouters
